export default __webpack_public_path__ + "static/media/banner-lake.93397c1e.jpg";